module.exports = __webpack_public_path__ + "static/media/priorityBoardingModalTotem.9b00c13e.png";